"use client";

import { c as _c } from "react/compiler-runtime";
import React from "react";
import { AdSlot } from "@/features/ads/AdSlot";
import { RelatedEntities } from "../../partials/RelatedEntities/RelatedEntities";
import { TabbedRelatedContent } from "../../partials/TabbedArticles/TabbedArticles";
import { ChallengeZoneSidebar } from "@/features/challenge-zone/ChallengeZoneSidebar";
import { useArticleData } from "../../context/ArticleDataContext";

/**
 * SidebarContent for the DefaultWithSidebar variant.
 * Contains:
 * 1. Banner placeholder
 * 2. Related entities (teams, players, competitions) - 1 per row
 * 3. Tabbed related content (related articles + latest from category) with minimal cards
 */
export function SidebarContent() {
  const $ = _c(9);
  const {
    relatedEntities,
    locale
  } = useArticleData();
  let t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <AdSlot id="sidebar-top" />;
    t1 = <RelatedEntities variant="compact" columns={1} className="" />;
    $[0] = t0;
    $[1] = t1;
  } else {
    t0 = $[0];
    t1 = $[1];
  }
  let t2;
  if ($[2] !== locale || $[3] !== relatedEntities) {
    t2 = <ChallengeZoneSidebar relatedEntities={relatedEntities} locale={locale} />;
    $[2] = locale;
    $[3] = relatedEntities;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  let t3;
  let t4;
  if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <TabbedRelatedContent variant="default" columns={1} className="" />;
    t4 = <AdSlot id="sidebar-bottom" />;
    $[5] = t3;
    $[6] = t4;
  } else {
    t3 = $[5];
    t4 = $[6];
  }
  let t5;
  if ($[7] !== t2) {
    t5 = <aside className="w-full md:w-60 md:min-w-60 lg:w-75 lg:min-w-75 shrink-0"><div className="sticky top-below-nav-gap space-y-6">{t0}{t1}{t2}{t3}{t4}</div></aside>;
    $[7] = t2;
    $[8] = t5;
  } else {
    t5 = $[8];
  }
  return t5;
}